export const AssignmentTypes = {
    Unavailability : 1,
    ProjectDispatch : 2,
    ServiceServiceCallDispatch : 3,
    ServiceWorkOrderDispatch : 4,
    FieldServiceDispatch : 5,
};